<script setup>
import { reactive, onMounted } from 'vue';
import router from '@/router';
import { store } from '@/store';

const state = reactive({
    navigationOptions: store.navigationOptions,
})

/**
 * Pushes route to routeName
 * @param {Object} opt option from state.navigationOptions
 */
function userClickedNavigationOption(opt) {
    router.push({ name: opt.routeName })
}

onMounted(()=>{
  if (store.userRole == 'physician'){
    state.navigationOptions = store.physicianNavigationOptions;
  } else if (store.userRole == 'secretary'){
    state.navigationOptions = store.secretaryNavigationOptions;
  }
})
</script>
<template>
    <div class="navigation-menu">
        <p v-for="(opt) in state.navigationOptions" :key="opt"
            :class="{ selected: opt.isSelected, unselected: !opt.isSelected }" @click="userClickedNavigationOption(opt)">
            {{ opt.name }}
        </p>
    </div>
</template>
<style lang="scss" scoped>

.navigation-menu {
    display: flex;
    align-self: flex-end;
    margin-bottom: 0;
    min-width: 24.875rem; // when we resize screen, text wraps and stretches vertically if no min width

    .unselected {
        &:hover {
            cursor: pointer;
            color: rgb(103, 58, 183);
        }
    }

    .selected {
        background-color: rgb(103, 58, 183);
        color: #fff;
        border-radius: 1rem;

        // &:hover {
            // cursor: pointer;
            // color: rgb(103, 58, 183);
            // // border: solid 1px rgb(0,0,0);

            // background-color: rgba(104, 58, 183, 0.1);

        // }
    }

    .selected,
    .unselected {
        margin: 1rem;
        padding: 0.5rem;
        display: flex;
        align-items: center;
        text-align: center;
    }
}

</style>